import {Component, ElementRef, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-donate',
  templateUrl: './donate.component.html'
})
export class DonateComponent implements OnInit {

  /**
   * prefix for all texts
   */
  @Input() textkeyPrefix: string;

  /**
   * toggle for the donation form
   */
  showDonationForm: boolean = false;

  /**
   * constructor
   * @param elementRef
   */
  constructor(private elementRef: ElementRef) {}

  /**
   * @inheritDoc
   */
  ngOnInit(): void {
    // add embed script from twingle
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.src = '//spenden.twingle.de/embed/generic';
    this.elementRef.nativeElement.appendChild(s);
  }

}
